import React from "react";
import styled from "styled-components";
import facebook from "../../Images/facebook.png";
import instagram from "../../Images/instagram.png";
import twitter from "../../Images/twitter.png";
import pinterest from "../../Images/pinterest.png";

const PostItemContainer = styled.div`
  margin-bottom: 1rem;
  border-radius: 15px;
  padding: 1rem;
  width: 100%;
  @media (max-width: 1024px) {
    flex-direction: column;
  }
`;
const PostInfo = styled.div`
  display: flex;
  justify-content: space-between;
  font-family: "Inter";
  width: 100%;

  @media (max-width: 1024px) {
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    font-family: "Inter";
  }
`;
const UserInfo = styled.div`
  display: flex;
  align-items: center;
  width: inherit;

  @media (max-width: 1024px) {
    margin-bottom: 0.5rem;
    flex-direction: column;
    display: flex;
    align-items: flex-start;
    max-width: 100%;
  }
`;
const UserImage = styled.img`
  width: 30px;
  height: 30px;
  border-radius: 50%;
  margin-right: 10px;
  margin-bottom: 10px;
`;
const Name = styled.p`
  font-weight: 600;
  font-family: "Inter";
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 100%;
  @media (max-width: 1024px) {
    max-width: 100%;
  }
`;
const Description = styled.p`
  font-size: 1rem;
  font-family: "Inter";
  word-wrap: break-word;
  overflow-wrap: break-word;
  hyphens: auto;
  max-width: 512px;
  @media (max-width: 1440px) {
    max-width: 212px;
  }
  @media (max-width: 1024px) {
    display: none;
  }
`;

const PostItem = ({
  custom_message,
  picture_url,
  product_name,
  selected_social_media,
  product_obj,
  post_id,
  setSelectedPost,
  selectedPost,
  selectedPlatform = { selectedPlatform },
}) => {
  const icons = { facebook, twitter, instagram, pinterest };
  const onClickPost = async (product_obj, post_id, selected_social_media) => {
    // console.log(
    //   "on click post item",
    //   product_obj,
    //   post_id,
    //   selected_social_media,
    //   picture_url
    // );
    setSelectedPost({
      ...product_obj,
      id: post_id,
      picture_url: picture_url,
      platform: selected_social_media,
    });
  };
  return (
    <PostItemContainer
      onClick={() =>
        onClickPost(product_obj, post_id, selected_social_media, picture_url)
      }
      className={`cursor-pointer postItem ${
        post_id === selectedPost.post_id ? "selectedPost" : ""
      } ${
        !selectedPlatform || selectedPlatform === selected_social_media
          ? "d-flex"
          : "d-none"
      }`}
    >
      <div className="d-flex flex-column postInfoSec">
        <PostInfo>
          <UserInfo>
            <UserImage
              src={icons[selected_social_media]}
              alt="social media img"
            />
            <Name>{product_name}</Name>
          </UserInfo>
        </PostInfo>
        <Description>{custom_message}</Description>
      </div>
      <div
        className="productImg d-flex align-items-center justify-content-center"
        style={{ width: "25%" }}
      >
        <img
          src={picture_url}
          alt="post image"
          style={{
            width: "100%",
            objectFit: "contain",
          }}
        />
      </div>
    </PostItemContainer>
  );
};

export default PostItem;
